import * as React from 'react';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { useUser } from 'utils/user';
import { UserEditFormView } from '../UserEditForm/view';
import { USER_UPDATE } from 'const/mutations';

export function UserProfileForm() {
    const user = useUser();
    const client = useApolloClient();

    const [userUpdate, { loading }] = useMutation(USER_UPDATE, {
        onCompleted({ appAccountUserUpdate }) {
            localStorage.setItem('user', JSON.stringify(appAccountUserUpdate.node));
            client.writeData({ data: { isLoggedIn: true, user: appAccountUserUpdate.node } });
        },
    });

    const onSubmit = (values, form, callback) => {
        userUpdate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    return <UserEditFormView user={user} profile={true} loading={loading} onSubmit={onSubmit} />;
}
